import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Li, P, Span } from 'shared';
import ProviderResultRow from './ProviderResultRow';
function ProviderResultsList({ results, isLoading, onSelect, }) {
    if (isLoading) {
        return (_jsx(P, { variant: "body-medium", className: "pay-with-alphaeon__results-status", children: "Searching\u2026" }));
    }
    if (results.length === 0) {
        return (_jsx(P, { variant: "body-medium", className: "pay-with-alphaeon__results-status", children: "No providers found. Try a different search term." }));
    }
    return (_jsxs("div", { className: "pay-with-alphaeon__results", children: [_jsxs(P, { variant: "body-small", className: "pay-with-alphaeon__results-count", children: ["We found", ' ', _jsxs(Span, { variant: "body-small", className: "font-bold", children: [results.length, " results"] })] }), _jsx("ul", { className: "pay-with-alphaeon__results-list", children: results.map((location) => (_jsx(Li, { variant: "body-large", listStyle: "disc", children: _jsx(ProviderResultRow, { location: location, onSelect: onSelect }) }, location.locationId))) })] }));
}
export default memo(ProviderResultsList);
